<template>
    <div class="vertical grow gallery-container" style="height: 100%" :style="`width: ${photos.length != 0 ? '70vw' : '35vw'}; min-width: 350px;`">
        <div :class="{'two-columns-template-modal' : photos.length > 0}" style="margin-top: 5px;">
            <div class="scrollbar-full" style="max-height: 70vh; overflow: auto;">
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('Problem') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{solution.problemTitle}}</span>
                        </td>
                    </tr>
                </div>

                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('Description') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{solution.description}}</span>
                        </td>
                    </tr>
                </div>

                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('WorkDone') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{solution.workDone}}</span>
                        </td>
                    </tr>
                </div>

                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('RequiredSpareParts') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{solution.requiredSpareParts}}</span>
                        </td>
                    </tr>
                </div>

                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('SystemStatusCheck') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{solution.systemStatusCheck}}</span>
                        </td>
                    </tr>
                </div>

                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('FurtherWork') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{solution.furtherWork}}</span>
                        </td>
                    </tr>
                </div>

                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('CreateDate') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{moment(solution.createDate).format('YYYY-MM-DD')}}</span>
                        </td>
                    </tr>
                </div>

                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{ $t('ResolvedDate') }}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{moment(solution.resolveDate).format('YYYY-MM-DD')}}</span>
                        </td>
                    </tr>
                </div>
            </div>
            <div style="background-color: rgba(243, 243, 243, 1)">
                <div id="photos-container" style="margin: auto;">
                    <div class="vertical" style="margin: auto;">
                        <div style="width: calc(0.5 * 70vw); height: 50vh; align-self: center; text-align: center; overflow: hidden; white-space: nowrap;" v-if="(photos.length > 0)">
                            <i class="arrow left" :style="[photos.length > 1 ? {'cursor': 'pointer' } : {'cursor': 'default'}]" @click="changePhoto(-1)"></i>
                            <img class="photo" :src="photos[activePhotoIndex].url" >
                            <i class="arrow right" :style="[photos.length > 1 ? {'cursor': 'pointer' } : {'cursor': 'default'}]" @click="changePhoto(1)"></i>
                        </div>
                        <div class="thumbnails horizontal">
                            <div v-for="(photo, index) in photos" :key="index" @click="activePhotoIndex = index">
                                <div class="thumbnail-container">
                                    <img :src="photo.url" class="thumbnail" v-bind:class="{ selectedThumbnail: activePhotoIndex == index}"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getSolution, getSolutionResourceById } from '@/api/api';
import moment from 'moment'

export default {
    props: {
        solutionObject: {
            required: true,
            type: Object
        },
        problemTitle: {
            required: true,
            type: String
        }
    },
    components: {

    },
    data() {
        return {
            solution: {},

            photos: [],
            activePhotoIndex: 0
        }
    },
    methods: {
        async getData() {
            var result = await getSolution(this.solutionObject.id)
            this.solution = result
            this.solution.problemTitle = this.problemTitle

            for (let i = 0; i < this.solution.resources.length; i++) {
                let img = await getSolutionResourceById(this.solution.resources[i]);
                let photo = URL.createObjectURL(new Blob([img.data], {
                type: img.headers['content-type']}));

                this.photos.push({
                    src: img,
                    url: photo,
                    id: this.solution.resources[i]
                });
            }
        },
        changePhoto(direction){
            if(direction > 0){
                if (this.activePhotoIndex + 1 < this.photos.length) {
                    this.activePhotoIndex++;
                } else {
                    this.activePhotoIndex = 0;
                }
            } else {
                if (this.activePhotoIndex > 0) {
                    this.activePhotoIndex--;
                } else {
                    this.activePhotoIndex = this.photos.length - 1
                }
            }
        },
        addPhoto(e){
            for(let i = 0; i < e.target.files.length; i++ ) {
                var photo = URL.createObjectURL(e.target.files[i]);
                this.photos.push({
                    src: e.target.files[i],
                    url: photo
                });
            }
            this.activePhotoIndex = this.photos.length - 1
        }
    },
    async mounted() {
        this.getData()
    }
}
</script>

<style scoped>
.gallery-container {
    background: #F9F9F9;
    box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
    border-radius: 5px;
}

.section-title {
    font-weight: bold;
    text-align: center;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
    justify-content: center;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
    margin: 0;
}

.info-field-row {
    align-self: center;
    width: 80%;
    margin: 0;
    padding-bottom: 5px;
}

.section-title {
    font-weight: bold;
}

select {
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

textarea, input[type="text"] {
    max-height: 300px;
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

.scrollbar-full {
    overflow-y: auto;
    overflow-x: hidden;
}

.scrollbar-full::-webkit-scrollbar-track
{
    border: 1px solid #A3D4E0;
	-webkit-box-shadow: 0 0 6px rgba(0,0,0,0.3);
	border-radius: 3px;
	background-color: white;
}

.scrollbar-full::-webkit-scrollbar
{
	width: 10px;
	background-color: white;
}

.scrollbar-full::-webkit-scrollbar-thumb
{
	border-radius: 3px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: rgb(0, 149, 178);
}
</style>



// WEBPACK FOOTER //
// src/components/Visits/Solutions/SolutionPreviewModal.vue